/**
* @name: user-recent-menu-list
* @author: weiyong
* @date: 2024-10-08 23:35
* @description：user-recent-menu-list
* @update: 2024-10-08 23:35
*/
<template>
  <div class="user-sear-menu-list w100b">
    <template v-if="menuList.length>0">
      <div  class="common-menu-main-li w100b" v-for="item in menuList">

        <template v-if="item.type==='menu'">
          <div class="w100b menu-group-title w100b" style="margin-bottom: 12px;">
            <h3 class="group-title">{{ item.label || item.name }}</h3>
          </div>

          <div class="son-item-list flex-div flex-wrap">
            <template v-for="sonItem in item.children">
              <template v-if="item.type==='menu'">
                <menu-li-menu :item="sonItem"/>
              </template>
              <template v-else>
                <menu-li-record :isCollectItemFlag="isCollectItem(sonItem)"    @click="selActiveOneMenu(sonItem)" :item="sonItem"/>
              </template>

            </template>
          </div>

        </template>
      </div>
    </template>
    <a-empty v-else/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "user-recent-menu-list",
});
</script>

<script lang="ts" setup>
import MenuLiMenu from './menu-li-menu.vue'
import MenuLiRecord from "@/layouts/layoutFrame/military/components/menu-li-record.vue";
import {useUserRecentMenu} from "@/layouts/layoutFrame/military/hooks/useUserRecentMenu";

const props=defineProps({
  menuList:{},
  collectMenuList:{}
})
const {menuList}=toRefs(props);
const {selActiveOneMenu}=useUserRecentMenu();

//判断是否已经收藏的菜单
const isCollectItem = (item) => {
  if(unref(menuList)&&Array.isArray(unref(menuList))&&unref(menuList).length>0){
    const colItem=unref(menuList).filter((itemDb)=>{
      return item.id===itemDb.id;
    })[0];
    if(colItem){
      return  true
    }
  }
  return false
}
</script>

<style type="text/css" lang="less">
.user-sear-menu-list{
  .menu-group-title{
    background-color:#FFF !important;
    font-size: 14px !important;
    position: relative;
    padding-left: 12px !important;
    &:before{
      content:' ';
      width:3px;
      height:16px;
      background-color: var(--primary-color,#0a6eff);
      left:2px;
      border-radius: 3px;
      position: absolute;
    }
  }
  .menu-li{
    width:178px;
  }
  .common-menu-main-li {
    margin-right: 12px;
    margin-top: 12px;
    cursor:pointer;
  }
}
</style>
